import script from "./ProjectView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=de238d42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de238d42"]])

export default __exports__